<!-- Header -->
<div class="tw-pr-2 tw-border-b tw-border-primary/10 tw-flex tw-justify-between tw-items-center">
  <h2 class="!tw-px-5 !tw-py-4 tw-text-primary tw-font-bold tw-text-lg">
    EDITAR PRECIO
  </h2>

  <button mat-icon-button (click)="onCancel()" autofocus="false">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="!tw-p-5 !tw-font-[inherit]">
  <form [formGroup]="editForm">
    <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-2">
      <!-- PVL -->
      <div>
        <app-form-field
          class="field tw-block tw-w-full"
          type="number"
          label="PVL"
          [fieldControl]="pvlControl | asFormControl"
        ></app-form-field>
      </div>

      <!-- Descuento -->
      <div>
        <app-form-field
          class="field tw-block tw-w-full"
          type="number"
          label="Descuento (%)"
          [fieldControl]="descuentoControl | asFormControl"
        ></app-form-field>
      </div>

      <!-- Recargo -->
      <div>
        <app-form-field
          class="field tw-block tw-w-full"
          type="number"
          label="Recargo (%)"
          [fieldControl]="recargoControl | asFormControl"
        ></app-form-field>
      </div>

      <!-- PVLN (calculado) -->
      <div>
        <app-form-field
          class="field tw-block tw-w-full"
          type="number"
          label="PVLN (calculado)"
          [fieldControl]="pvlnControl | asFormControl"
          [readOnly]="readOnly"
        ></app-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="!tw-p-5 !tw-border-t !tw-border-primary/10">
  <button
    mat-button
    (click)="onCancel()"
  >
    Cancelar
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="onSave()"
    [disabled]="!editForm.valid"
  >
    Guardar
  </button>
</mat-dialog-actions>
